"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueProps = ValueProps;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const value_prop_1 = require("./partials/value-prop");
const value_props_module_scss_1 = __importDefault(require("./value-props.module.scss"));
function ValueProps({ className, propsData, columnClasses, valuePropClassName, headingTag = 'h3', headingClassName, descriptionClassName, imageClassName
// descriptionHidden = false, // for expand feature
// containerWidth = do we want to provide a container?
 }) {
    const classes = (0, classnames_1.default)('row row--center-xs', value_props_module_scss_1.default['container'], className);
    /* set generic classes for all value props */
    const colWidthClasses = columnClasses || calcColumns(propsData.length);
    const renderValueProps = propsData.map((propData, i) => {
        const compiledPropData = {
            ...propData,
            className: (0, classnames_1.default)(colWidthClasses, valuePropClassName, propData.className),
            headingClassName,
            headingTag,
            descriptionClassName,
            imageClassName
        };
        return (0, jsx_runtime_1.jsx)(value_prop_1.ValueProp, { ...compiledPropData }, `valueProp${i}`);
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: classes, children: renderValueProps }));
}
/* TODO: revisit "standard" grid breaks with Design */
const calcColumns = (itemsLength) => {
    switch (itemsLength) {
        case 1:
            return `col col-xs--12`;
        case 2:
            return `col col-xs--12 col--md-6`;
        case 3:
            return `col col-xs--12 col--md-4`;
        case 4:
            return `col col-xs--12 col--md-6 col--lg-3`;
        default:
            return `col col--xs-12`;
    }
};
ValueProps.propTypes = {
    /** Classname(s) for the row of value props set to accompany the existing grid classes of `row row--center-xs` */
    className: prop_types_1.default.string,
    /** Grid column classnames to replace the default set, which is based on the number of value props. Make sure to include the base `col` class (ex. `col col--xs-6 col--md-3`) */
    columnClasses: prop_types_1.default.string,
    /** Classname(s) to apply to each value prop which will accompany the default grid classes (`col ...`) or those set by `columnClasses` */
    valuePropClassName: prop_types_1.default.string,
    /** Array of value prop data objects to define the icon, heading, and descriptions. NOTE: the `icon` can be any kind of element - svg, icon, div wrapping an icon, etc */
    propsData: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        /** Icon or SVG component to pass to a value prop */
        icon: prop_types_1.default.node.isRequired,
        /** Heading text to be inside a defined heading tag, it is rendered with dangerouslySetInnerHTML */
        heading: prop_types_1.default.string.isRequired,
        /** Rendered below the heading with dangerouslySetInnerHTML into a paragraph tag */
        description: prop_types_1.default.string,
    })).isRequired,
    /** Heading tag applied to all value prop headingText; passed to ValueProp */
    headingTag: prop_types_1.default.oneOf([
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'span'
    ]),
    /** Classname applied to all heading (ex `t-heading3`); passed to ValueProp */
    headingClassName: prop_types_1.default.string,
    /** State of descriptions, to be toggled by external action; passed to ValueProp */
    descriptionHidden: prop_types_1.default.string,
    /** Classname applied to all descriptions (ex `t-bodySm`); passed to ValueProp */
    descriptionClassName: prop_types_1.default.string,
    /** Classname applied to all images; passed to ValueProp */
    imageClassName: prop_types_1.default.string
};
//# sourceMappingURL=value-props.js.map